import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class CheckboxValidationStrategy extends FormValidationStrategy {
  validate(valueString, isRequired) {
    if (isRequired && parseInt(valueString) === 0) {
      return {
        isValid: false,
        message: "",
      };
    }

    return {
      isValid: true,
      message: "",
    };
  }
}
